








import { Component, Prop, Vue } from 'vue-property-decorator';
import { ADD_MODULE_BUTTON_TEXT, REMOVE_MODULE_BUTTON_TEXT } from './consts';

@Component
export default class ModuleButton extends Vue {
  @Prop({ type: Boolean, default: true })
  readonly isAddModuleBtnMode!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isDisabled!: boolean;

  get buttonText(): string {
    return this.isAddModuleBtnMode
      ? ADD_MODULE_BUTTON_TEXT
      : REMOVE_MODULE_BUTTON_TEXT;
  }

  get buttonModClass(): string {
    const { isAddModuleBtnMode, isDisabled } = this;
    if (isDisabled) return 'modulebtn_disabled';
    return isAddModuleBtnMode ? 'modulebtn_green' : 'modulebtn_red';
  }

  clickHandler() {
    const { isDisabled } = this;
    if (isDisabled) return;
    this.$emit('toggledModule');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/modules/modulebutton/ModuleButton.vue